import React, { FunctionComponent, ReactElement } from 'react';
import { Box, Typography } from '@material-ui/core';
import { IVariantFeature } from '../../../../../../model/IVariantSpecifications';
import SpecificationsDetailItem from '../specificationsDetailItem/SpecificationsDetailItem';
import specificationsDetailListStyles from './specificationsDetailListStyles';

export interface ISpecificationsDetailListProps {
  title: ReactElement;
  variantFeatures: IVariantFeature;
}

const SpecificationsDetailList: FunctionComponent<ISpecificationsDetailListProps> = ({ title, variantFeatures }) => {
  const styles = specificationsDetailListStyles();

  return (
    <Box mb={3} data-test="customise:specifications_details">
      <Typography className={styles.title} data-test="customise:specifications_title">
        {title}
      </Typography>
      {Object.keys(variantFeatures).map(category => (
        <SpecificationsDetailItem key={category} category={category} specifications={variantFeatures[category]} />
      ))}
    </Box>
  );
};

export default SpecificationsDetailList;
